import { Stack } from "@mui/material";
import SalesTabs from "./tabs";

const Clients = () => {
  return (
    <Stack maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <SalesTabs />
    </Stack>
  );
};

export default Clients;
